import React from 'react';
import { useTranslation } from 'react-i18next';
import '../v2/pages/timesheet/timeSheetsPage/timeSheetsPage.scss';
import { useState } from 'react';
import CustomDatePicker from '../../src/v2/pages/dashboard/CustomDatePicker'

interface TimesheetFilterHeaderProps {
  fromDate: string;
  toDate: string;
  onFromDateChange: (date: string) => void;
  onToDateChange: (date: string) => void;
  onLoad: () => void;
  onSave: () => void;
  placeholder?: string;
  hasNewEntries?: boolean;
}

const TimesheetFilterHeader: React.FC<TimesheetFilterHeaderProps> = ({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  placeholder = "YYYY-MM-DD",
  onLoad,
  onSave,
  hasNewEntries = false,
}) => {
  const { t } = useTranslation();
  
  const isLoadDisabled = (!fromDate && !!toDate) || (!!fromDate && !toDate);
  const [openPicker, setOpenPicker] = useState<null | 'from' | 'to'>(null);
  
  return (
    <div className="timesheet-filter-header">
      <div className="filter-field">
        <label className="filter-label" style={{ color: "var(--text-icons-light-base-main, #252525)", fontFamily: "Plus Jakarta Sans", fontSize: 14, fontStyle: "normal", fontWeight: 500, lineHeight: "20px", marginBottom: "0px !important" }}>
          {t("FROMS")}
        </label>
        <CustomDatePicker value={fromDate} onChange={onFromDateChange} isOpen={openPicker === "from"} onOpen={() => setOpenPicker("from")} onClose={() => setOpenPicker(null)} />
      </div>

      <div className="filter-field">
        <label className="filter-label" style={{ color: "var(--text-icons-light-base-main, #252525)", fontFamily: "Plus Jakarta Sans", fontSize: 14, fontStyle: "normal", fontWeight: 500, lineHeight: "20px", marginBottom: "0px !important" }}>
          {t("TO")}
        </label>
        <CustomDatePicker value={toDate} onChange={onToDateChange} isOpen={openPicker === "to"} onOpen={() => setOpenPicker("to")} onClose={() => setOpenPicker(null)} />
      </div>

      <button
        className={`load-btn ${isLoadDisabled ? "disabled" : ""}`}
        onClick={onLoad}
        disabled={isLoadDisabled}
        style={{
          opacity: isLoadDisabled ? 0.5 : 1,
          cursor: isLoadDisabled ? "not-allowed" : "pointer",
        }}
      >
        {t("LOAD")}
      </button>

      <button className="save-timesheet-btn" onClick={onSave} disabled={!hasNewEntries}>
        {t("SAVE_TIMESHEET")}
      </button>
    </div>
  );
};

export default TimesheetFilterHeader;
